import React from 'react';
import PropTypes from 'prop-types';
import MenuList from 'src/components/widgets/MenuList';
import MenuWrapper from 'src/components/widgets/MenuWrapper';
import { Box } from '@mui/material';
import myCollectionPageMenuItems from 'src/menuItems/myCollectionPageMenuItems';

export default function MyCollectionPageMenu({ drawerMode }) {
  return (
    <Box
      pb={2}
      sx={{
        overflowX: 'hidden'
      }}
    >
      <MenuWrapper>
        {myCollectionPageMenuItems.map((menu) => {
          return (
            <MenuList key={menu.title} menu={menu} drawerMode={drawerMode} />
          );
        })}
      </MenuWrapper>
    </Box>
  );
}

MyCollectionPageMenu.propTypes = {
  drawerMode: PropTypes.string
};
